




import Vue from 'vue';
import Component from 'vue-class-component';
import { contacts, layout } from '../../../shared/shared/store/namespaces';
import CreateContactForm from '../components/CreateContactForm.vue';
import { CONTACT_GET_CONTACT_TO_BE_UPDATED } from '@/modules/contacts/shared/store/contacts.getters';
import { Contact } from '@/modules/contacts/shared/domain/contact';
import { ContactFormInterface } from '../../shared/domain/contact-form.interface';
@Component({
    components: { CreateContactForm },
})
export default class UpdateContactView extends Vue {
    mounted() {
        this.CHANGE_TITLE({ route: ['CONTACTOS'], title: 'ACTUALIZAR CONTACTO' });
    }

    @layout.Mutation('changeTitle') CHANGE_TITLE!: (title: {
        route: string[];
        title: string;
    }) => void;

    @contacts.Getter(CONTACT_GET_CONTACT_TO_BE_UPDATED)
    CONTACT_TO_BE_UPDATED!: ContactFormInterface;
}
